import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import styles from "../sidequest.module.scss";
import sidequestLogo from "../../../assets/images/sidequest-white.png";


const Hero = () => {
  return (
    <section className={styles.hero}>
      <div className={styles.heroWash} />
      <div className={styles.container}>
        <div className={styles.heroGrid}>
          <motion.div
            className={styles.heroContent}
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4 }}
          >
            <div className={styles.heroEyebrow}>
              <img src={sidequestLogo} alt="Sidequest" className={styles.heroEyebrowLogo} />
              <span className={styles.heroEyebrowText}>Sidequest Developer Program</span>
            </div>

            <h1>
              Built for developers <br />
              on <span className={styles.accent}>Sidequest</span>.
            </h1>

            <p>
              You're getting verified access to KeyQuest's VR market
              intelligence platform &mdash; track keywords, benchmark
              competitors, and grow your app's visibility on Meta Quest.
            </p>

            <div className={styles.heroActions}>
              <a href="#register-form" className={`${styles.btn} ${styles.btnPrimary}`}>
                Request Access
              </a>
              <a href="#benefits" className={styles.heroLink}>
                See what&apos;s included
              </a>
            </div>

            {/* <div className={styles.heroFacts}>
              {facts.map((fact, idx) => (
                <React.Fragment key={fact}>
                  {idx !== 0 && <span className={styles.heroFactDivider} />}
                  <span>{fact}</span>
                </React.Fragment>
              ))}
            </div> */}

            <p className={styles.heroFootnote}>
              Already verified? <Link to="/login">Sign in to your account</Link>
            </p>
          </motion.div>

          <motion.div
            className={styles.accessCard}
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4, delay: 0.15 }}
          >
            <div className={styles.accessCardHeader}>
              <span className={styles.accessCardLabel}>Developer Pass</span>
              <span className={styles.accessCardMark}>KQ</span>
            </div>

            <div className={styles.accessCardFields}>
              <div>
                <span className={styles.accessCardFieldLabel}>Program</span>
                <span className={styles.accessCardFieldValue}>Sidequest Partnership</span>
              </div>
              <div>
                <span className={styles.accessCardFieldLabel}>Access Level</span>
                <span className={styles.accessCardFieldValue}>Verified Partner</span>
              </div>
              <div>
                <span className={styles.accessCardFieldLabel}>Status</span>
                <span className={styles.accessCardFieldValue}>Applications Open</span>
              </div>
            </div>

            <p className={styles.accessCardRef}>REF &mdash; SQ &middot; 2026</p>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
